// H1 fix (AC-2/AC-3) — builds a ContainerAppId -> ContainerAppName lookup from an App
// Instance's ContainerApps (as returned by GET /api/app-instances/{id}), so the
// Pipelines list can render the Target Container column's *name* instead of the raw
// int id, and so the client-side search can match by container name too. Mirrors how
// the wizard's TargetContainerStep already resolves container names (
// useGetDetailAppInstance -> ContainerApps[].ContainerAppName).
export const buildContainerNameById = (containerApps = []) => {
  const map = new Map();

  (containerApps ?? []).forEach((c) => {
    if (c?.Id !== undefined && c?.Id !== null) {
      map.set(c.Id, c.ContainerAppName);
    }
  });

  return map;
};

export default buildContainerNameById;
